exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-7cd4cd94] {\n  font-weight: bold;\n  font-size: large;\n}\n", ""]);
